export default {
  picker: {
    titleGeometries: 'Select geometries',
    titleMeshes: 'Select meshes',
    descriptionGeometries:
      'Pick geometries to mesh on the fly. Each item adds rows to the design-point matrix.',
    descriptionMeshes:
      'Pick existing meshes to use as inputs. Each item adds rows to the design-point matrix.',
    searchGeometries: 'Search geometries...',
    searchFiles: 'Search files...',
    sortGeometries: 'Sort geometries',
    sortRecent: 'Recent',
    sortOldest: 'Oldest',
    sortAToZ: 'A → Z',
    sortZToA: 'Z → A',
    sortSmallest: 'Smallest',
    sortLargest: 'Largest',
    sortTypeAToZ: 'Type A → Z',
    sortTypeZToA: 'Type Z → A',
    ascendingFlip: 'Ascending — click to flip',
    descendingFlip: 'Descending — click to flip',
    sortAscending: 'Sort ascending',
    sortDescending: 'Sort descending',
    selectedCount: '{{count}} selected',
    cancel: 'Cancel',
    done: 'Done',
    noGeometries: 'No geometries found. Upload geometries in MeshGen first.',
    noMatches: 'No matches for “{{query}}”',
  },
  dropzone: {
    dragDropGeometries: 'Drag & drop geometries, or',
    browseFiles: 'Browse files',
    geometryFormats: 'STEP, STP, OBJ, STL • up to 1 GB each',
    uploadFailed: 'Upload failed',
    uploadFailedReason: 'Upload failed: {{reason}}',
    rejectedOne: '{{name}}: invalid type or too large.',
    rejectedMany: '{{count}} files rejected — invalid type or too large.',
    cancelUpload: 'Cancel upload',
    dismiss: 'Dismiss',
  },
  tree: {
    noGeometries: 'No geometries found. Upload geometries in MeshGen first.',
    filteringBy: 'Filtering by:',
    clear: 'Clear',
    noMeshesMatch: 'No meshes match {{filters}}.',
    meshCount_one: '{{count}} mesh',
    meshCount_other: '{{count}} meshes',
    elements: '{{value}} elements',
    removeTagFilter: 'Remove "{{label}}" filter',
    filterByTag: 'Filter by "{{label}}"',
  },
  // Mesh row chips derived by `describeMesh` in utils/meshTags.ts. Keys
  // stay locale-invariant on the tag itself; these strings drive the
  // rendered label.
  meshChips: {
    cfdInt: 'CFD · Int',
    cfdExt: 'CFD · Ext',
    cht: 'CHT',
    fea: 'FEA',
    wrap: 'Wrap',
    repair: 'Repair',
    tet: 'Tet',
    hex: 'Hex',
    poly: 'Poly',
    bl: 'BL',
    tagged: 'Tagged',
    untagged: 'Untagged',
    sharedFaceJoins: 'Shared-face {{count}}',
    sharedFaceJoinsHint:
      'These body pairs share mesh nodes across faces, so the mesh carries a bonded, continuous interface.',
    nodeOnlyJoins: 'Node-only {{count}}',
    nodeOnlyJoinsHint:
      'These body pairs meet only at an edge or point. They have no shared-face area for face conduction.',
    gapContacts: 'Unjoined pair {{count}}',
    gapContactsHint:
      'Measured nearby but unjoined surfaces. These are contact candidates, not active ties or bonds.',
    taggedMissingInternal: 'Missing {{parts}} in boundary assignment',
    taggedMissingCht: 'Missing {{parts}}',
    roleInlet: 'inlet',
    roleOutlet: 'outlet',
    roleFluidRegion: 'fluid region',
    roleSolidRegion: 'solid region',
  },
  geometryPicker: {
    title: 'Geometries',
    searchGeometries: 'Search geometries...',
    noGeometries: 'No geometries found. Upload geometries in MeshGen first.',
    noMatches: 'No matches for “{{query}}”',
    prev: 'Prev',
    next: 'Next',
  },
  meshDropzone: {
    uploading: 'Uploading {{name}}...',
    uploaded: '{{name}} uploaded',
    failed: '{{name}} failed',
    tryAgain: 'Try again',
    uploadFailed: 'Upload failed',
    invalidFile: 'Invalid file type or too large.',
    dragDropMesh: 'Drag & drop mesh file, or',
    browseFromFile: 'Browse from file',
    unitWarning:
      'Uploaded meshes must already be in meters (SI). Khorium does not rescale uploads — a mesh authored in mm will be 1000× too large. Generate the mesh in MeshGen to set its unit.',
  },
  viewer: {
    selectToPreview: 'Select files from the sidebar to preview',
    showingCadHint: 'Showing CAD tessellation — switch to Mesh for cell view',
    showingMeshHint:
      'Showing mesh — point heat loads and node picks need mesh nodes',
    viewLabel: 'View',
    autoCad: 'Auto (CAD)',
    autoMesh: 'Auto (Mesh)',
    cadTessellation: 'CAD tessellation',
    meshCells: 'Mesh cells',
    previewUnsupported: 'preview unsupported for this file format',
    previewPreparing: 'preparing geometry preview…',
    previewUnavailable: 'geometry preview unavailable',
  },
  studyTree: {
    files: 'Files',
    change: 'Change',
    selectFiles: 'Select files',
    openInMeshgen: 'Open in MeshGen',
    removeFromSelection: 'Remove from selection',
    removeItem: 'Remove {{filename}} from selection',
    meshStatus: 'Mesh status: {{status}}',
    qualityFailed: 'Failed',
    qualityCancelled: 'Cancelled',
    qualityMeshing: 'Meshing...',
    qualityNa: 'Quality n/a',
    qualityReady: 'Quality ready',
    qualitySicn: 'SICN {{value}}',
    qualityGamma: 'Gamma {{value}}',
    qualitySkew: 'Skew {{value}}',
  },
} as const;
